export default __webpack_public_path__ + "static/media/Artisan-Signature.cefe2844.otf";